import React from "react";
import { InfoPageWrapper } from "../ui/InfoPageWrapper";
import { PrivacyPolicyIntro } from "../components/privacyPolicyIntro";
import { PrivacyPolicySummary } from "../components/privacyPolicySummary";
import { TableOfContentsPrivacyPolicy } from "../components/tableOfContentsPrivacyPolicy";

const PrivacyPolicy = () => {
  return (
    <InfoPageWrapper>
      <div className="font-sans flex flex-col text-primary-700 gap-6-res">
        <PrivacyPolicyIntro />
        <PrivacyPolicySummary />
        <TableOfContentsPrivacyPolicy />
      </div>
    </InfoPageWrapper>
  );
};

export default PrivacyPolicy;
